import React from 'react';
import { DollarSign, Lock } from 'lucide-react';
import { PRIVATE_PAYOUT_EXCLUDED_NOTE } from '../../../utils/bookingSource';

const RevenueBreakdown = ({ revenueAnalytics = {}, overview = {} }) => {
 const formatCurrency = (amount) => {
 if (amount === null || amount === undefined || amount === '') return '$0.00';
 const numAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
 if (isNaN(numAmount) || !isFinite(numAmount)) return '$0.00';
 return `$${numAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
 };

 const platformRevenue =
 revenueAnalytics.platform_revenue ??
 overview.platform_revenue ??
 revenueAnalytics.total_revenue ??
 overview.total_revenue ??
 0;
 const privateOffline =
 revenueAnalytics.private_offline_collected ?? overview.private_offline_collected ?? 0;

 return (
 <div className="product-panel p-4 sm:p-6">
 <h2 className="text-lg font-semibold text-ink mb-1">Revenue Breakdown</h2>
 <p className="text-xs text-ink-tertiary mb-4">Platform totals exclude private offline bookings</p>
 <div className="space-y-4">
 <div className="flex items-center justify-between p-3 bg-surface-muted/50 rounded-md">
 <div>
 <p className="text-sm text-ink-secondary">Platform revenue</p>
 <p className="text-xl font-bold text-ink mt-1">{formatCurrency(platformRevenue)}</p>
 <p className="text-xs text-ink-tertiary mt-0.5">Collected via platform payments</p>
 </div>
 <DollarSign className="w-8 h-8 text-emerald-600" />
 </div>
 <div className="grid grid-cols-2 gap-4">
 <div className="p-3 bg-surface-muted/50 rounded-md">
 <p className="text-xs text-ink-secondary mb-1">Platform fees</p>
 <p className="text-lg font-semibold text-ink">
 {formatCurrency(revenueAnalytics.platform_fees || overview.platform_fees || 0)}
 </p>
 </div>
 <div className="p-3 bg-surface-muted/50 rounded-md">
 <p className="text-xs text-ink-secondary mb-1">Vendor payouts</p>
 <p className="text-lg font-semibold text-ink">
 {formatCurrency(revenueAnalytics.vendor_payouts || 0)}
 </p>
 </div>
 </div>
 {privateOffline > 0 && (
 <div className="flex items-center justify-between p-3 bg-surface-muted border border-border rounded-md">
 <div>
 <p className="text-sm text-ink font-medium">Private offline collected</p>
 <p className="text-lg font-semibold text-ink mt-1">{formatCurrency(privateOffline)}</p>
 <p className="text-xs text-ink mt-0.5">{PRIVATE_PAYOUT_EXCLUDED_NOTE}</p>
 </div>
 <Lock className="w-7 h-7 text-ink shrink-0" />
 </div>
 )}
 {revenueAnalytics.average_transaction > 0 && (
 <div className="p-3 bg-surface-muted/50 rounded-md">
 <p className="text-xs text-ink-secondary mb-1">Avg platform transaction</p>
 <p className="text-lg font-semibold text-ink">
 {formatCurrency(revenueAnalytics.average_transaction)}
 </p>
 </div>
 )}
 </div>
 </div>
 );
};

export default RevenueBreakdown;
